export const adminFeaturePaths = {
  activationsKeywordsExact: "/brand/brand-shield/keywords/exact",
  activationsKeywordsOther: "/brand/brand-shield/keywords/other",
  activationsCampaigns: "/brand/brand-shield/campaigns",
  brandInfringement: "/brand/brand-shield/brand-infringement",

  liveMonitoring: "/brand/brand-shield/scraping",
  liveMonitoringAdd: "/admin/features/live-monitoring/add",
  liveBiddingSearchActiveMode: "/brand/brand-shield/active-mode",
  liveBiddingSearchKoBiddingMaxCpc: "/brand/brand-shield/ko-bidding/max-cpc",
  liveBiddingSearchKoBiddingTroas: "/brand/brand-shield/ko-bidding/troas",
  liveBiddingSearchKoBiddingTcpa: "/brand/brand-shield/ko-bidding/tcpa",
  liveBiddingSearchKoBiddingTargetImpressionShare: "/brand/brand-shield/ko-bidding/target-impression-share",
  liveBiddingSearchKoBiddingAuto: "/brand/brand-shield/ko-bidding-auto",
  liveBiddingCampaignBased: "/admin/features/live-bidding/campaign-based",
  liveBiddingAdGroupBased: "/admin/features/live-bidding/ad-group-based",
}; 